import {
  SHIPPER_TRUCK_STACIONARY,
  SHIPPER_TRUCK_PORTABLE,
  ACTIVE,
  CANCELED,
  DISCONNECTED,
} from "../views/Map/MapPageTypes";
import { NUMBER_ACCOUNT } from "utils/variables";

import shippingStacionaryInfo from "../assets/icons/ICONOS-68PX-FASE-2b.1-GENERIC-01.png";
import shippingPortableInfo from "../assets/icons/ICONOS-68PX-FASE-2b.1-GENERIC-02.png";

// disconnected
import shippingPortableInfoDisconnected from "../assets/icons/68PX-CILIN-ROJAS.png";
import shippingStacionaryInfoDisconnected from "../assets/icons/68PX-PIPAS-ROJAS.png";

// services
import serviceCallCenter from "assets/icons/68x68-operadora-confirma.png";
import serviceInRoute from "assets/icons/68x68-confirmacasa.png";

// notes
import notesStacionary from "assets/icons/68x68-alertatanque.png";
import notesPortable from "assets/icons/68x68-alertacilindros.png";
import notesStacionaryCancel from "assets/icons/68x68-cancela-tanque.png";
import notesPortableCancel from "assets/icons/68x68-cancela-cinlindros.png";
import { getTime } from "./parseDates";

export const iconType = (type, lastLogin) => {
  const typeI = type ? type.toUpperCase() : "";
  const date = lastLogin && getTime(lastLogin);
  const isNow = date && date.isToday();

  const unit = `${typeI}${isNow ? "" : DISCONNECTED}`;

  switch (unit) {
    case `${SHIPPER_TRUCK_STACIONARY}${DISCONNECTED}`:
      return shippingStacionaryInfoDisconnected;

    case `${SHIPPER_TRUCK_PORTABLE}${DISCONNECTED}`:
      return shippingPortableInfoDisconnected;

    case SHIPPER_TRUCK_STACIONARY:
      return shippingStacionaryInfo;

    case SHIPPER_TRUCK_PORTABLE:
      return shippingPortableInfo;

    default:
      return shippingStacionaryInfo;
  }
};

export const iconServiceType = (account) => {
  if (account && account !== NUMBER_ACCOUNT) {
    return serviceCallCenter;
  } else {
    return serviceInRoute;
  }
};
export const iconNoteType = (type, status) => {
  const typeI = type ? type.toUpperCase() : "";
  const statusI = status ? status.toUpperCase() : "";
  const icon = `${typeI}${statusI}`;

  switch (icon) {
    case `${SHIPPER_TRUCK_STACIONARY}${ACTIVE}`:
      return notesStacionary;

    case `${SHIPPER_TRUCK_PORTABLE}${ACTIVE}`:
      return notesPortable;

    case `${SHIPPER_TRUCK_STACIONARY}${CANCELED}`:
      return notesStacionaryCancel;

    case `${SHIPPER_TRUCK_PORTABLE}${CANCELED}`:
      return notesPortableCancel;

    default:
      return notesStacionary;
  }
};
